import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/Utilities/CommonFunctions';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ClientDataService {
  constructor(
    private http: HttpClient
  ) { }

  getBusinessList(pageNumber: any, searchText: string, isActive: string, sortData: any, expiryStatus?: string, subscriptionType?: string) {
    let params = new HttpParams().set('page', pageNumber)
    if (searchText != null && searchText != '') {
      params = params.set('search', searchText);
    }
    if (isActive != null && isActive != '') {
      params = params.set('isActive', isActive);
    }
    if (expiryStatus != null && expiryStatus != '') {
      params = params.set('expiryStatus', expiryStatus);
    }
    if (subscriptionType != null && subscriptionType != '') {
      params = params.set('subscriptionType', subscriptionType);
    }
    if (sortData != null && sortData != '') {
      params = params.set('sortBy', sortData.sortBy);
    }
    if (sortData != null && sortData != '') {
      params = params.set('sortDirection', sortData.sortDirection);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/list';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json'
      }),
      params: params
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  getAllBusinessList() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/list';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json'
      }),
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }


  editBusiness(business_id: string, clientData: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/' + business_id + '/update';
    // console.log('Business Hours edit Service Data ---> ' + JSON.stringify(businessHour));
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
    };
    return this.http.post(url, clientData, httpOptions).pipe(timeout(60000));
  }

  validateEin(business_id: string, triggeredByLabel?: string) {
    let params = new HttpParams();
    if (triggeredByLabel) {
      params = params.set('triggeredByLabel', triggeredByLabel);
    }
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/' + business_id + '/ein/validate';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
      params: params
    };
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

  getEinVerificationHistory(business_id: string) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/' + business_id + '/ein/history';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  getSingleBusiness(business_id: string) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/' + business_id;
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  enableDisableBusiness(business_id: string, isActive: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/' + business_id + '/activate?isActive=' + isActive;
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json'
      }),
    };
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

  updateSmsNumber(business_id: string, smsNo: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/business/' + business_id + '/updateSMSNo';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
        'smsNo': smsNo,
      }),
    };
    return this.http.post(url, null, httpOptions).pipe(timeout(60000));
  }

  getBusinessType() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/anonymous/businessType/list';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  getTimezone() {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/anonymous/timezones';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  getRootUser(businessId: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/user/rootUser/' + businessId;
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(url, httpOptions).pipe(timeout(60000));
  }

  resetRootUserPassword(userId: any, businessId: any, passwordData: any) {
    const url = environment.API_URL_BUSINESS_ADMIN + '/api/user/' + userId + '/resetPassword';
    const TOKEN = CommonFunctions.getTokenOfBusiness();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + TOKEN,
        'Content-Type': 'application/json',
        'BusinessId': businessId.toString(),
      }),
    };
    return this.http.post(url, passwordData, httpOptions).pipe(timeout(60000));
  }
}
